import React from 'react';
import styled from 'styled-components';
import { Icon } from '../../../../../components';
import iconFlat from '../../../../../../assets/icons/icon-piso.svg';
import iconClassroom from '../../../../../../assets/icons/icon-ambiente.svg';

export const Div = styled.div`
  color: #161d1f;
  display: flex;
  align-items: center;
  margin: 0 0 24px 0;

  span {
    margin: 0 0 0 4px;
  }
`;

export const Box = styled.div<{ borderColor?: string }>`
  color: #161d1f;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 12px;
  margin: 0px 0 12px 0;
  width: 100%;
  background: #f7fafb;
  border: 1px solid;
  border-color: ${({ borderColor = 'var(--card-focus)' }) => borderColor};
  border-radius: 8px;
`;

export const Line = styled.div`
  width: 100%;
  background-color: #7a959f;
  height: 1px;
`;

const SpanGray = styled.div`
  height: 44px;
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--text-text01);
  span {
    color: var(--text-text02);
  }
`;

interface InPersonEventBoxProps {
  classroom: string;
  flat: string;
  campus: string;
  address: string;
}

const InPersonEventBox = ({
  classroom,
  flat,
  campus,
  address
}: InPersonEventBoxProps) => (
  <div data-testid="cmp-event-detail-in-person-box">
    <Div>
      <Icon name="map-pin" size={16} color="var(--neutrals-neutral02)" />
      <span style={{ whiteSpace: 'nowrap', marginRight: 8, fontSize: 14 }}>
        ¿Cómo llegar?
      </span>
      <Line />
    </Div>

    <Box borderColor="#7A959F">
      <SpanGray>
        <img src={iconClassroom} alt="" />
        Ambiente: <span>{classroom || '-'}</span>
      </SpanGray>
      <Line />
      <SpanGray>
        <img src={iconFlat} alt="" />
        Piso: <span>{flat || '-'}</span>
      </SpanGray>
    </Box>
    <Box borderColor="#7A959F">
      <p style={{ padding: '0 0 8px 0' }}>
        <strong>{campus || '-'}</strong>
      </p>
      <p>{address || '-'}</p>
    </Box>
  </div>
);

export default InPersonEventBox;
